import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const accountService = {
  get_me: async (token) => {
    const response = await https.get(`${API_ROUTES.ACCOUNT.GET_INFO}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  update: (payload, token) => {
    return https.put(API_ROUTES.ACCOUNT.UPDATE, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};
